module.exports = __webpack_public_path__ + "static/media/spt-logo.32d4d172.png";